(function () {
  var cfg = window.urbAiBadge || {};
  var marker = String(cfg.marker || 'ai').toLowerCase();
  if (!marker) return;

  var gap = Number(cfg.gap) || 12;
  var pos = cfg.position || 'br';
  var re = new RegExp('(^|[^a-z0-9])' + marker.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^a-z0-9]|$)');
  var raf = 0;
  var keys = [];

  String(cfg.videos || '').split(/\s+/).forEach(function (u) {
    var m = String(u).match(/[0-9a-f]{20,40}/);
    if (m && keys.indexOf(m[0]) === -1) keys.push(m[0]);
  });

  function fileOf(url) {
    if (!url) return '';
    var u = String(url).split('?')[0].split('#')[0];
    var n = u.slice(u.lastIndexOf('/') + 1);
    try { n = decodeURIComponent(n); } catch (e) {}
    return n.toLowerCase();
  }

  function hit(url) {
    if (!url) return false;
    var s = String(url);
    for (var i = 0; i < keys.length; i++) {
      if (s.indexOf(keys[i]) !== -1) return true;
    }
    var n = fileOf(s);
    return !!n && re.test(n);
  }

  function urlsOf(el) {
    var out = [];
    var tag = el.tagName;
    if (tag === 'IMG') {
      out.push(el.currentSrc || el.getAttribute('src'));
      var ss = el.getAttribute('srcset');
      if (ss) out.push(ss.split(',')[0].trim().split(' ')[0]);
    } else if (tag === 'VIDEO') {
      out.push(el.getAttribute('poster'));
      out.push(el.getAttribute('src'));
      var src = el.querySelectorAll('source');
      for (var i = 0; i < src.length; i++) out.push(src[i].getAttribute('src'));
    }
    var bg = el.style && el.style.backgroundImage;
    if (bg && bg !== 'none') {
      var m = bg.match(/url\((['"]?)(.*?)\1\)/);
      if (m) out.push(m[2]);
    }
    return out;
  }

  function isMedia(el) {
    return el.tagName === 'IMG' || el.tagName === 'VIDEO';
  }

  function anchorOf(el) {
    if (el.tagName === 'IMG' && el.parentElement && el.parentElement.tagName === 'PICTURE') return el.parentElement;
    return el;
  }

  function relative(el) {
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
  }

  function mediaOf(badge) {
    var prev = badge.previousElementSibling;
    if (prev && prev.getAttribute && prev.getAttribute('data-urb-ai') === '1') return prev;
    var host = badge.parentElement;
    if (host && host.getAttribute && host.getAttribute('data-urb-ai') === '1') return host;
    return null;
  }

  function place(media, badge) {
    var parent = badge.offsetParent || badge.parentElement;
    if (!parent) { badge.hidden = true; return; }
    var mr = media.getBoundingClientRect();
    if (!mr.width || !mr.height) { badge.hidden = true; return; }
    badge.hidden = false;
    var pr = parent.getBoundingClientRect();
    var top = mr.top - pr.top + parent.scrollTop;
    var left = mr.left - pr.left + parent.scrollLeft;
    var bw = badge.offsetWidth;
    var bh = badge.offsetHeight;
    badge.style.top = (pos === 'tl' || pos === 'tr' ? top + gap : top + mr.height - bh - gap) + 'px';
    badge.style.left = (pos === 'tl' || pos === 'bl' ? left + gap : left + mr.width - bw - gap) + 'px';
  }

  function attach(el) {
    var anchor = anchorOf(el);
    var badge = document.createElement('span');
    badge.className = 'urb-ai-badge';
    badge.setAttribute('data-urb-ai-badge', '');
    badge.setAttribute('role', 'note');
    badge.setAttribute('aria-label', window.urbStrings.aiGenerated);
    el.setAttribute('data-urb-ai', '1');
    anchor.setAttribute('data-urb-ai', '1');
    if (isMedia(el)) {
      if (!anchor.parentElement) return;
      relative(anchor.parentElement);
      anchor.insertAdjacentElement('afterend', badge);
    } else {
      relative(el);
      el.appendChild(badge);
    }
    place(anchor, badge);
    if (window.ResizeObserver) {
      new ResizeObserver(function () { place(anchor, badge); }).observe(anchor);
    }
  }

  function refresh() {
    var list = document.querySelectorAll('[data-urb-ai-badge]');
    for (var i = 0; i < list.length; i++) {
      var m = mediaOf(list[i]);
      if (m) place(m, list[i]);
    }
  }

  function scan() {
    var nodes = document.querySelectorAll('img, video, [style*="background-image"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-urb-ai') === '1') continue;
      if (el.closest('[data-urb-ai-badge]')) continue;
      var urls = urlsOf(el);
      for (var j = 0; j < urls.length; j++) {
        if (hit(urls[j])) { attach(el); break; }
      }
    }
  }

  function boot() {
    scan();
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', function () { boot(); setTimeout(boot, 1200); });
  window.addEventListener('resize', function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(refresh);
  });
})();